import React from 'react';
import { IntlProvider } from 'react-intl';
import localeStore from '../../stores/Locale'

export function LanguageProvider(props) {
  const locale = localeStore();
  return (
    <IntlProvider
      locale={locale.code}
      messages={locale.getMessages()}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

export default LanguageProvider;
